<template>
  <div  :class="{ 'mb-9': ((roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || roleInSpace == 'space_admin' && subscriptionEnds || (role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')) }">
    <AlertMessages
      v-if="alertValue"  
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <SystemBarTopTrial v-if="(roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial'"/>
    <SystemBarTopCancelSubscription v-if="roleInSpace == 'space_admin' && subscriptionEnds"/>
    <SystemBarTopPaymentFailed v-if="roleInSpace == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"/>
    <v-app-bar
      app
      clipped-left
      clipped-right
      elevation="0"
      outlined
      v-if="workflow.attributes && !loadingData"
    >   
      <v-toolbar-title class="ml-n3">
        <router-link
          v-if="!mobile()"
          to="/"
        >
          <v-img
            v-if="logo == null"
            data-testid="logo-space"
            src="../assets/rtplogo.svg"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="logo"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
        </router-link>
         <router-link
          v-else
          to="/"
        >
          <v-img
            v-if="icon == null"
            data-testid="logo-space"
            src="../assets/rtpicon.png"
            max-height="40"
            :max-width="mobile() ? '40' : '40' "
            class="justify-center mx-4"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="icon"
            max-height="40"
            :max-width="mobile() ? '40' : '40' "
            class="justify-center mx-4"
            contain
            position="top left"
          />
        </router-link>
      </v-toolbar-title>
      <h3
        v-if="!mobile()"
        class="pl-6 no-break"
      >
        <div v-if="workflowId == workflow.id">
          <v-clamp
            autoresize
            :max-lines="2"
          >
            {{ workflow.attributes.title }}
          </v-clamp>
        </div>
      </h3>
      <h4
        v-if="mobile() && (workflowId == workflow.id)"
        style="font-size:14px"
        class="pl-3 no-break"
      >
        <v-clamp
          autoresize
          :max-lines="1"
        >
          {{ workflow.attributes.title}}
        </v-clamp>
      </h4>
      <v-spacer />
      <div>
       <h3>{{$t('status')}} </h3> 
      </div>
      <div style="width:140px" class="d-flex justify-left">
       <v-switch data-testid="status-workflow" v-model="workflow.attributes.is_active"  
                          @click="editStatusWorkflow(workflow)"
              color="success" class="ma-3 mr-0" hide-details inset
              :disabled="workflow.attributes.is_broken"
              ></v-switch>
              <v-alert data-testid="status-workflow-label" v-show="workflowStatus" transition="fade-transition" class="dis" :class="workflow.attributes.is_active ? 'pa-0 my-3 mr-3 success--text' : 'pa-0 my-3 mr-3 grey--text'">
                {{ workflow.attributes.is_active? $t('live') : $t('paused') }}
              </v-alert>
        </div>
        <v-tooltip left>        
        <template v-slot:activator="{ on }">
          <!--<v-btn v-on="on" :to="'/activity/'+ $route.params.id +'/page/'+ $route.params.pageid" rounded elevation="0" exact>{{ $t('exit') }}<v-icon>mdi-logout</v-icon></v-btn>-->
          <v-btn
            rounded
            elevation="0"
            exact
            data-testid="exit-button"
            v-on="on"
            @click="
              dialogVisible=true, 
              confirmationDialogTitle=$t('confirmationDialogTitleExitWorkflowEdit'), 
              confirmationDialogText=$t('confirmationDialogTextExitWorkflowEdit'),
              cdSubmitBtnColor='success', 
              cdCancelBtnColor='darktext',
              confirmationDialogSubmitBtn=$t('publish')
              confirmationDialogCancelBtn=$t('saveWithoutPublishBtn')"
          >
            {{ $t('exit') }}
            <v-icon>mdi-logout</v-icon>
          </v-btn> 
        </template>
        <span>{{ $t('exitEditMode') }}</span>
      </v-tooltip>
    </v-app-bar>
    <ConfirmationDialog 
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :cd-cancel-btn-color="cdCancelBtnColor"
      :cd-submit-btn-color="cdSubmitBtnColor"
      :disabled="disablePublish"
      data-testid="confirmation-dialog"
      @input="clickOutside"
      @close="redirectToWorkflowOverview"
      @proceedSubmit="saveWorkflow"
    />
  
  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import i18n from '../plugins/i18n'
import AlertMessages  from './AlertMessages'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import { updateWorkflowTitle } from '../api/workflowApi'
// import Vue from 'vue'
import { ruleRequired, ruleValidMin2Max70Characters } from '../rules/formRules.js';
import SystemBarTopTrial from '../components/SystemBarTopTrial';
import SystemBarTopCancelSubscription from '../components/SystemBarTopCancelSubscription'
import SystemBarTopPaymentFailed from '../components/SystemBarTopPaymentFailed'
import { eventBus } from "../eventbus";
import ConfirmationDialog from './ConfirmationDialog';

export default {
    components: {
        VClamp,
        AlertMessages,
        SystemBarTopTrial,
        SystemBarTopCancelSubscription,
        SystemBarTopPaymentFailed,
        ConfirmationDialog
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
          valid: true,
            titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
            cookie:false,
            isAuth: window.$cookies.get("token")? true: false,
            userId: window.$cookies.get('id'),
            spaceId: window.$cookies.get('space_id'),
            space: window.location.host.split('.')[0],
            subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            icon: localStorage.space ? JSON.parse(localStorage.space).icon : null,
            roleInSpace: localStorage.space ? JSON.parse(localStorage.space).role : null,
            idps: localStorage.space ? JSON.parse(localStorage.space).idps : [],
            entityType: "activity",
            alertMsg: '',
            alertType: '',
            alertValue:false,
            workflowId: this.$route.params.id,
            loadingData: false,
            role:'',
            status:true,
            dialogVisible: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            cdSubmitBtnColor:'',
            cdCancelBtnColor:'',
            disablePublish: false,
            workflowStatus: false
        }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.name
      })
    },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
    workflow() {
      return this.$store.state.workflow
    }
  },
    async created(){
      eventBus.$on('disablePublish',(val)=>{
        this.disablePublish = val        
      })
      this.loadingData = true
      await this.getWorkflow()
      this.loadingData = false
    },
    beforeDestroy() {
      eventBus.$off('disablePublish')
    },
    methods:{
      async getWorkflow() {
        if(this.$store.state.workflow && this.$store.state.workflow.id == this.workflowId)
        {
          //nothing for now
          this.$store.dispatch("getWorkflow", this.workflowId)
          .catch(error => {
            if (error.response.status == 403) {
              this.$router.push({ name: 'PageAccessDenied' })
            }
            if (error.response.status == 404) {
              this.$router.push({ name: 'PageNotFound' })
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t('serverError')
            }
          })
        }else {
          this.$store.dispatch("getWorkflow", this.workflowId)
          .catch(error => {
            if (error.response.status == 403) {
              this.$router.push({ name: 'PageAccessDenied' })
            }
            if (error.response.status == 404) {
              this.$router.push({ name: 'PageNotFound' })
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t('serverError')
            }
          })
        }
      },
      async editStatusWorkflow(item) {
      try {
         var data = {}
          if(item.attributes.is_active == true){
              data = {
                data: {
                  type: "workflows",
                  id: item.id,
                  attributes: {
                    title: item.attributes.title.trim(),
                    is_active: true
                  },
                  relationships: {
                      space: {
                          data: {
                              type: "spaces",
                              id: this.spaceId
                          }
                      }
                  }
                },
              };
          }else{
            data = {
                data: {
                  type: "workflows",
                  id: item.id,
                  attributes: {
                    title: item.attributes.title.trim(),
                    is_active: false
                  },
                  relationships: {
                      space: {
                          data: {
                              type: "spaces",
                              id: this.spaceId.toString()
                          }
                      }
                  }
                },
              };
          }
        const response = await updateWorkflowTitle(item.id, data);
        if (response) {
          if (response.status == 200) {
            await this.getWorkflow()
            eventBus.$emit("changeStatus");
            this.workflowStatus = !this.workflowStatus
            setTimeout(() => {
              this.workflowStatus = !this.workflowStatus;
            }, 3000);
          }
        }
      } catch (e) {
        if (e.response) {
          this.selectedItem= {}
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t("serverError");
          }
        } else {
          this.alertValue = true
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    redirectToWorkflowOverview(){
      this.dialogVisible=false
      this.$router.push({path: '/workflow/' + this.workflowId})
    },
    clickOutside(){
      this.dialogVisible=false
    },
    saveWorkflow(){
      eventBus.$emit('saveWorkflow')
    }
  },
}
</script>
<style>
.v-input--switch .v-input__control .v-input__slot {
  margin-bottom:0px !important;
}
</style>